import { Dispatch, Action } from 'redux'
import { TaskPlanActionListMapDispatchReturnType } from './types/TaskPlanActionListMapDispatchReturnType'

export const TaskPlanActionListMapDispatch = (
  _dispatch: Dispatch<Action>
): TaskPlanActionListMapDispatchReturnType => {
  return {}
}
